import { SchemadrawTextContainer } from "./types";

export const originalContainerCache: {
  [id: SchemadrawTextContainer["id"]]:
  | {
    height: SchemadrawTextContainer["height"];
  }
  | undefined;
} = {};

export const updateOriginalContainerCache = (
  id: SchemadrawTextContainer["id"],
  height: SchemadrawTextContainer["height"],
) => {
  const data =
    originalContainerCache[id] || (originalContainerCache[id] = { height });
  data.height = height;
  return data;
};

export const resetOriginalContainerCache = (
  id: SchemadrawTextContainer["id"],
) => {
  if (originalContainerCache[id]) {
    delete originalContainerCache[id];
  }
};

export const getOriginalContainerHeightFromCache = (
  id: SchemadrawTextContainer["id"],
) => {
  return originalContainerCache[id]?.height ?? null;
};
